import { getProductCategory, getProductUnity, getProducts, createProduct, getStockMove } from "../api/inventoryApi";
import { getUsers } from "../api/manageUser";

export const fetchProductData = async () => {
  try {
    const [categoryResponse, unitResponse, productResponse, stockMoveResponse, usersRespone] = await Promise.all([
      getProductCategory(),
      getProductUnity(),
      getProducts(),
      getStockMove(),
      getUsers()
    ]);

    return {
      categories: categoryResponse.data.categories,
      unities: unitResponse.data.unities,
      products: productResponse.data.products,
      stockMoves: stockMoveResponse.data.stockMoves,
      users: usersRespone.data.users,

    };
  } catch (error) {
    console.log(error);
    throw new Error(error.response?.data?.message || "Erreur lors de la récupération des données.");
    
  }
};



export const submitProduct = async (productData) => {
    try {
      await createProduct(productData);
      return { success: true };
    } catch (error) {
      return { success: false, message: error.response?.data?.message || "Erreur lors de l'ajout du produit." };
    }
};